import { initialExploreQuery } from './dummyQuery';

export const setExploreQuery = (
    state: ExploreQueryT,
    query: ExploreQueryT,
): ExploreQueryT => {
    const { metrics, dimensions, filters } = query;
    return {
        ...state,
        metrics,
        dimensions,
        filters,
    };
};

export const resetExplore = (): ExploreQueryT => initialExploreQuery;
